// SarıyerSidebar.jsx

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  {
    label: "Maslak Mahallesi Halı Yıkama",
    path: "/sariyer/maslak-hali-yikama",
    description:
      "Maslak Mahallesi’nde halılarınız modern sistemlerde, çevre dostu ürünlerle hijyenik şekilde temizlenir."
  },
  {
    label: "Tarabya Halı Yıkama",
    path: "/sariyer/tarabya-hali-yikama",
    description:
      "Tarabya bölgesinde halılarınızı özenle yıkayıp, steril şekilde kapınıza teslim ediyoruz."
  },
  {
    label: "Zekeriyaköy Halı Yıkama",
    path: "/sariyer/zekeriyakoy-hali-yikama",
    description:
      "Zekeriyaköy’de el dokuma ve değerli halılarınızı zarar vermeden profesyonelce temizliyoruz."
  },
  {
    label: "İstinye Halı Yıkama",
    path: "/sariyer/istinye-hali-yikama",
    description:
      "İstinye semtinde halılarınızı en son teknoloji ile yıkıyor, hijyenik koşullarda teslim ediyoruz."
  },
  {
    label: "Sarıyer Merkez Halı Yıkama",
    path: "/sariyer/merkez-hali-yikama",
    description:
      "Sarıyer merkezde hizmet veren profesyonel ekibimizle halılarınızı titizlikle temizliyoruz."
  },
  {
    label: "Yeniköy Halı Yıkama",
    path: "/sariyer/yenikoy-hali-yikama",
    description:
      "Yeniköy bölgesinde doğal ürünlerle halı yıkama, ücretsiz servis ve hızlı teslim garantisi sunuyoruz."
  },
  {
    label: "Rumelihisarı Halı Yıkama",
    path: "/sariyer/rumelihisari-hali-yikama",
    description:
      "Rumelihisarı’nda halı yıkama hizmetimizle değerli halılarınızı ilk günkü gibi temizliyoruz."
  }
];

const SariyerSidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">SARIYER SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm border border-gray-200">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex justify-between items-center px-3 py-2 text-red-800 font-bold hover:bg-red-100 rounded-md"
        >
          Hizmet Bölgeleri {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>

        {isOpen && (
          <div className="mt-2 space-y-3">
            {ServiceArea.map((area, index) => (
              <div key={index}>
                <Link
                  to={area.path}
                  className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                    location.pathname === area.path
                      ? "bg-red-600 text-white"
                      : "text-red-900 hover:bg-green-100 hover:text-red-800"
                  }`}
                >
                  {area.label}
                </Link>
                <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SariyerSidebar;